import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { JsonPatchOperation } from '@/shared/types/common';

type PatchOwnersParams = {
  resourceId: string;
  apiPath: string;
  operations: JsonPatchOperation[];
};

export const patchOwners = async ({ apiPath, resourceId, operations }: PatchOwnersParams): Promise<void> => {
  try {
    if (operations.length > 0) {
      await openMetadataApiClient.patch(`${apiPath}/${resourceId}`, operations, {
        headers: {
          'Content-Type': 'application/json-patch+json',
        },
      });
    }
  } catch (error) {
    console.error('Failed to patch owners:', error);
    throw error;
  }
};
